
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import Container from "../container/container.vue";

@Component({
  components: {
    Container,
  },
})
export default class Popup extends Vue {
  @Prop() errorMsg!: string;
  @Prop() title!: string;

  mounted() {
    document.body.style.overflow = 'hidden';
  }

  beforeDestroy() {
    document.body.style.overflow = 'initial';
  }

  @Emit("close")
  private close() {}
}
